import { createSelector } from 'reselect'
import visualizationSelector from './visualizationSelector'

const aveStringSelector = createSelector(
    visualizationSelector,
    (visualization): string => visualization.aveString,
)

export default aveStringSelector
